import React from 'react';
import { LockIcon } from 'lucide-react';
import { FormData } from '../types';
import { fieldCatalog } from '../utils/config';
import { formatValue } from '../utils/format';
import { METRIC_ACCENTS, metricBadge, metricCaption, metricSubBadge } from '../utils/metrics';
interface MetricCardsProps {
  values: FormData;
  metricIds: string[];
}
export function MetricCards({
  values,
  metricIds
}: MetricCardsProps) {
  const metrics = metricIds.map(id => fieldCatalog[id]).filter(Boolean).slice(0, 5);
  if (metrics.length === 0) return null;
  const columns = metrics.length >= 5 ? 'sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5' : metrics.length === 4 ? 'sm:grid-cols-2 xl:grid-cols-4' : metrics.length === 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-2';
  return <div className={`grid grid-cols-1 gap-3 ${columns}`} role="list" aria-label="Loan summary metrics" data-id="element-280" data-mp="2mhhi76fo0q5v">
      {metrics.map((field, index) => {
      const accent = METRIC_ACCENTS[index % METRIC_ACCENTS.length];
      const caption = metricCaption(field.id, values);
      const badge = metricBadge(field.id, values);
      const subBadge = metricSubBadge(field.id, values);
      const display = formatValue(field.type, values[field.id]);
      return <article key={field.id} role="listitem" className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-281" data-mp="21vcn6vg5num7" data-mpi={index}>
            <div className={`h-1 w-full ${accent.bar}`} data-id="element-282" data-mp="2axlz9pr2nw1p" />
            <div className="px-4 py-3" data-id="element-283" data-mp="2auzozicsr2fs">
              <p className="truncate text-[10px] font-bold uppercase tracking-wider text-slate-500" data-id="element-284" data-mp="2pmi1v7ad0gux">
                {field.label}
              </p>
              <p className={`mt-1 truncate text-2xl font-bold tabular-nums ${accent.value}`} data-id="element-285" data-mp="2knoxq5gyq27f">
                {display || '—'}
              </p>
              {caption && <p className="mt-1 truncate text-[11px] text-slate-400" data-id="element-286" data-mp="2towkpre13gm7">{caption}</p>}
              {(badge || subBadge) && <div className="mt-2 flex flex-wrap items-center gap-1" data-id="element-287" data-mp="1r8ck5s96qefm">
                  {badge && <span className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-semibold ${accent.badge}`} data-id="element-288" data-mp="20avji2dri8x4">
                      {subBadge && <LockIcon className="h-3 w-3" data-id="element-289" data-mp="253ezt73u3i5m" />}
                      {badge}
                    </span>}
                  {subBadge && <span className="inline-block rounded bg-slate-100 px-1.5 py-0.5 text-[11px] font-semibold tabular-nums text-slate-600" data-id="element-290" data-mp="2ey6tw0y7jmvn">
                      {subBadge}
                    </span>}
                </div>}
            </div>
          </article>;
    })}
    </div>;
}